export default __webpack_public_path__ + "static/media/18.0adeb95b.png";